export enum FabricPluginName {
  HISTORY = 'history',
  ZOOM = 'zoom',
  SELECTION = 'selection',
  GRID = 'grid',
  HOTKEYS = 'hotkeys',
  PLACEHOLDER = 'placeholder',
  DIRTY = 'dirty',
  LAYER = 'layer',
  LAYOUT_BLOCKS = 'layout-blocks',
  RESIZE_NORMALIZE = 'resize-normalize',
  ALIGNMENT = 'alignment',
  RECT_CORNERS = 'rect-corners',
  FILL_GRADIENT = 'fill-gradient',
  FONT_LOADING = 'font-loading',
}
